/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/viz/shared/models/SelectorsModel.js"/>
/// <reference path="~/js/viz/shared/models/DataResponseModel.js"/>
/// <reference path="~/js/viz/shared/routers/VizRouterBase.js"/>
/// <reference path="~/js/viz/bar/views/BarView.js"/>
/// <reference path="~/js/viz/bar/views/HeaderView.js"/>
/// <reference path="~/js/viz/bar/views/NoBarDataView.js"/>
/// <reference path="~/js/viz/bar/config/Config.js"/>

(function() {
  "use strict";
  var ns, sharedNs;

  ns = window.nspace("ccc.viz.bar");
  sharedNs = window.nspace("ccc.viz.shared");

  ns.BarVizRouter = sharedNs.routers.VizRouterBase.extend({
    routes: {
      "": "initializeViews",
      ":indicatorId": "initializeViews",
      ":indicatorId/:characteristicIds": "initializeViews",
      ":indicatorId/:characteristicIds/:locationIds": "initializeViews",
      ":indicatorId/:characteristicIds/:locationIds/:dataFormatId":
        "initializeViews",
      ":indicatorId/:characteristicIds/:locationIds/:dataFormatId/:timeFrameId":
        "initializeViews"
    },

    /**
     * This method will only ever be invoked a single time, so use it to initialize
     * the model/view classes and trigger the initial rendering
     */
    initializeViews: function(
      indicatorId,
      characteristicIds,
      locationIds,
      dataFormatId,
      timeFrameId
    ) {
      //// MODELS ////

      function getValue(raw) {
        if (typeof raw === "undefined" || raw === "a") {
          return undefined;
        }
        return raw;
      }

      // Create the selectors model, which represents anything that is selectable by the user and tracked in the URL
      this.selectorsModel = new sharedNs.models.SelectorsModel();
      this.selectorsModel.set(
        {
          indicatorId: getValue(indicatorId),
          characteristicIds: this.getArrayFromModelProperty(characteristicIds),
          dataFormatId: getValue(dataFormatId),
          timeFrameId: getValue(timeFrameId),
          locationIds: this.getArrayFromModelProperty(locationIds)
        },
        {
          silent: true
        }
      );

      // Create the data response model, the model that is responsible for querying the server-side for data,
      // storing the response, and triggering updates to other views after the response has been retrieved
      this.dataModel = new ns.models.DataResponseModel({
        selectorsModel: this.selectorsModel,
        dispatcher: this.dispatcher,
        dataUrl: window.ccc.viz.bar.config.Config.dataUrl
      });

      //// VIEWS ////

      this.views = {
        // Loading spinner (no model required)
        loadingSpinner: new sharedNs.views.LoadingSpinnerView({
          dispatcher: this.dispatcher
        }),

        // Source/Definition/Notes
        sourceDefinitionNotesView: new sharedNs.views.SourceDefinitionNotesView(
          {
            selectorsModel: this.selectorsModel,
            model: this.dataModel
          }
        ),

        // Selectors. These must be instantiated late, since these views are used to bootstrap
        // the selectors model values, and certain other views need to hear when the selectors model changes.
        selectorsView: new ns.views.SelectorsView({
          model: this.selectorsModel,
          indicatorGroupId: this.indicatorGroupId,
          dispatcher: this.dispatcher,
          selectorData: {
            indicatorGroupId: this.indicatorGroupId,
            vizType: "Bar"
          }
        }),

        barView: new ns.views.BarView({
          selectorsModel: this.selectorsModel,
          model: this.dataModel,
          el: "#bar-chart-container"
        }),

        headerView: new ns.views.HeaderView({
          selectorsModel: this.selectorsModel,
          model: this.dataModel
        }),

        noBarDataView: new ns.views.NoBarDataView({
          selectorsModel: this.selectorsModel,
          model: this.dataModel
        })
      };

      this.completeRouterInitialization();
    },

    routeUrlParts: function() {
      return [
        this.selectorsModel.get("indicatorId"),
        this.getStringFromArrayProperty(
          this.selectorsModel.get("characteristicIds")
        ),
        this.getStringFromArrayProperty(this.selectorsModel.get("locationIds")),
        this.selectorsModel.get("dataFormatId"),
        this.selectorsModel.get("timeFrameId")
      ];
    }
  });
})(_);
